import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
//import { Typography } from '@material-ui/core';

import Grid from '@material-ui/core/Grid';

import ReactTooltip from "react-tooltip"

const styles = theme => ({
  container: {
    textAlign: 'center',
    //borderLeft: '3px solid #165469',
    fontFamily: 'Nunito Sans SemiBold',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: '110px',
    maxHeight: '110px',
    /*
    [theme.breakpoints.up('tablet')]: {
      minHeight: '140px',
      maxHeight: '140px',
    }, [theme.breakpoints.up('md')]: {
      minHeight: '125px',
      maxHeight: '125px',
    },
    */
  },
  heading: {
    color: '#105269!important',
    fontSize: '14pt',
    textAlign: 'center',
    width: '100%',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    width: '100%',
    //paddingLeft: '5px',
  },
  hoverable: {
    backgroundColor: 'rgba(255,255,255,0)!important',
    '&:hover': {
      cursor: 'pointer',
    },
    minHeight: '50px',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  imageContainer: {
    //position:'absolute',
    //border:'1px solid black',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '80px',
    height: '80px',
    clipPath: 'circle(35px at 50% 50%)',
    /*
    [theme.breakpoints.down('xs')]: {
      left:'30px',
      top:'250px',
      width:'45px',
      height:'45px',
    },
    [theme.breakpoints.up('sm')]: {
      left:'40px',
      top:'300px',
      width:'40px',
      height:'40px',
    },
    [theme.breakpoints.up('md')]: {
      width:'80px',
      height:'80px',
    },
    [theme.breakpoints.up('lg')]: {
      width:'180px',
      height:'140px',
      clipPath: 'ellipse(80px 60px at 50% 45%)',
    },
    */
  },
  selectorImage: {
    //border:'1px solid red',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center!important',
    //width: '100%',
    //height: 0,
    //minHeight: '50px',
    width: '40px',
    height: '40px',
    paddingTop: '10px',

  },
  /*
  solar: {
    backgroundImage: 'url("/images/spw_energy_selector/solar_energy.svg")',
  },
  windOnshore: {
    backgroundImage: 'url("/images/spw_energy_selector/wind_onshore.svg")',
  },
  windOffshore: {
    backgroundImage: 'url("/images/spw_energy_selector/wind_offshore.svg")',
  },
  */
  solar: {
    backgroundImage: 'url("/images/spw_energy_selector/solar_white.svg")',
  },
  windOnshore: {
    backgroundImage: 'url("/images/spw_energy_selector/wind_onshore_white.svg")',
  },
  windOffshore: {
    backgroundImage: 'url("/images/spw_energy_selector/wind_offshore_white.svg")',
  },

  toolTip: {
    textAlign: 'left',
    color: '#08716e!important',
    backgroundColor: '#aaaaaa',
    fontFamily: 'Nunito Sans Regular!important',
  },
});

function energySourceSelector(props) {

  const { classes } = props;
  let textTooltipSolar
  let textTooltipWindOnshore
  let textTooltipWindOffshore
  //let suggestionText
  let chooseEnergySource

  switch (props.lang) {
    case "de":
      textTooltipSolar = "Solarmodule"
      textTooltipWindOnshore = "Onshore-Windkraftanlagen"
      textTooltipWindOffshore = "Offshore-Windkraftanlagen"
      //suggestionText= 'Click the buttons to choose the energy source' 
      chooseEnergySource = 'Wählen Sie die Energiequelle'
      break
    case "en":
      textTooltipSolar = "Solar panels"
      textTooltipWindOnshore = "Onshore wind turbines"
      textTooltipWindOffshore = "Offshore wind turbines"
      //suggestionText= 'Click the buttons to choose the energy source' 
      chooseEnergySource = 'Choose the energy source'
      break
    case "fr":
    default:
      textTooltipSolar = "Panneaux solaires"
      textTooltipWindOnshore = "Turbines éoliennes onshore"
      textTooltipWindOffshore = "Turbines éoliennes offshore"
      //suggestionText= 'Cliquez les boutons on ou off à choisir la source d\'énergie' 
      chooseEnergySource = 'Choisissez la source d\'énergie'
      break
  }

  const tooltipSolar =
    <ReactTooltip id='solar_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipSolar}</p>
    </ReactTooltip>

  const tooltipWindOnshore =
    <ReactTooltip id='wind_onshore_tooltip' type='light' place='right' className={classes.toolTip}>
      <p>{textTooltipWindOnshore}</p>
    </ReactTooltip>

  const tooltipWindOffshore =
    <ReactTooltip id='wind_offshore_tooltip' type='light' place='left' className={classes.toolTip}>
      <p>{textTooltipWindOffshore}</p>
    </ReactTooltip>

  const boolHigherHeader = (props.windowWidth >= 1280 &&
    (
      (props.lang === "de" && props.windowWidth < 1660) ||
      (props.lang === "en" && props.windowWidth < 1536) ||
      props.windowWidth < 1440
    )
  )
  return (

    <Grid item container
      className={classes.container + ' mediumgreen'}
      style={{
        minHeight: (boolHigherHeader ? '130px' : '110px'),
        maxHeight: (boolHigherHeader ? '130px' : '110px'),
      }}
    >
      <Grid item className={classes.heading}>
        <div
          className={'  mediumgreen'}>
          {chooseEnergySource}
        </div>
      </Grid>
      <Grid item className={classes.buttonContainer}>
        <div className={classes.hoverable}>
          <div className={classes.imageContainer + (props.currentTech.solar ? " bgdarkyellow" : " bgmediumgrey")}>
            <div
              className={classes.selectorImage + " " + classes.solar}
              data-for='solar_tooltip'
              data-tip='solar_tooltip'
              data-energy_source='solar'
              onClick={props.setEnergySource}
            >
            </div>
          </div>
          {tooltipSolar}
        </div>
        <div className={classes.hoverable}>
          <div className={classes.imageContainer + (props.currentTech.wind ? " bgdarkblue" : " bgmediumgrey")}>
            <div
              className={classes.selectorImage + " " + classes.windOnshore}
              data-for='wind_onshore_tooltip'
              data-tip='wind_onshore_tooltip'
              data-energy_source='wind'
              onClick={props.setEnergySource}
            >
            </div>
          </div>
          {tooltipWindOnshore}
        </div>
        <div className={classes.hoverable}>
          <div className={classes.imageContainer + (props.currentTech.windOffshore ? " bgbrightblue" : " bgmediumgrey")}>
            <div
              className={classes.selectorImage + " " + classes.windOffshore}
              data-for='wind_offshore_tooltip'
              data-tip='wind_offshore_tooltip'
              data-energy_source='windOffshore'
              onClick={props.setEnergySource}
            >
            </div>
          </div>
          {tooltipWindOffshore}
        </div>
      </Grid>
    </Grid>
  );
}

energySourceSelector.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(energySourceSelector);
